import { Suspense } from "react";
import { useSelector } from "react-redux";
import { HashRouter, Redirect, Route, Switch } from "react-router-dom";
import AutoDailyReload from "./Components/Layout/AutoDailyReload";
import HeaderMain from "./Components/Layout/HeaderMain";
import { routes } from "./Routes/Routes";
import "./Style/style.scss";
// import GoToWebPage from './Components/GoToWebPage'

const App = () => {
  const isLogin = useSelector((state) => state.auth.isLogin);

  const isAddedToHome = useSelector((state) => state.persistedParams.isAddedToHome);

  // if (window.screen.width > 540 && window.screen.height > 720 ) return <GoToWebPage/> ;

  // if (!isAddedToHome) return <AddToHome />
  // if (!isLogin) return <Login />

  return (
    <HashRouter>
      <HeaderMain />
      <AutoDailyReload />
      <Suspense fallback={<div></div>}>
        <Switch>
          {routes.map((route, index) => {
            return (
              <Route
                key={index}
                path={route.path}
                name={route.name}
                // component={route.component}
                render={(props) => <route.component {...props} />}
              />
            );
          })}
          <Redirect form="/" to="/home" />
        </Switch>
      </Suspense>
      {/* <Footer /> */}
    </HashRouter>
  );
};

export default App;
